// Generated by purs version 0.14.5
"use strict";
var Control_Monad_Except_Trans = require("../Control.Monad.Except.Trans/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_JSDate = require("../Data.JSDate/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Nullable = require("../Data.Nullable/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_String_Pattern = require("../Data.String.Pattern/index.js");
var Data_Variant_Internal = require("../Data.Variant.Internal/index.js");
var Kishimen = require("../Kishimen/index.js");
var Locale = require("../Locale/index.js");
var TofuJSON = require("../TofuJSON/index.js");
var Types_CostGroup = require("../Types.CostGroup/index.js");
var Types_Project = require("../Types.Project/index.js");
var Utils = require("../Utils/index.js");
var Visible = (function () {
    function Visible() {

    };
    Visible.value = new Visible();
    return Visible;
})();
var Hidden = (function () {
    function Hidden() {

    };
    Hidden.value = new Hidden();
    return Hidden;
})();
var stringFilterFunction = function (v) {
    if (v.string instanceof Data_Maybe.Just) {
        return Data_String_CodeUnits.contains(v.string.value0);
    };
    if (v.string instanceof Data_Maybe.Nothing) {
        return Data_Function["const"](true);
    };
    throw new Error("Failed pattern match at FoldingTable.Filter (line 246, column 3 - line 248, column 26): " + [ v.string.constructor.name ]);
};
var selectionFilterFunction = function (v) {
    if (v.selection instanceof Data_Maybe.Just) {
        return function (v1) {
            return v1 === Data_Maybe.fromMaybe(v.selection.value0.value)(v.selection.value0.display);
        };
    };
    if (v.selection instanceof Data_Maybe.Nothing) {
        return Data_Function["const"](true);
    };
    throw new Error("Failed pattern match at FoldingTable.Filter (line 268, column 3 - line 270, column 26): " + [ v.selection.constructor.name ]);
};
var numericFilterFunction = function (v) {
    if (v.min instanceof Data_Maybe.Just && v.max instanceof Data_Maybe.Nothing) {
        return function (v1) {
            return v1 >= v.min.value0;
        };
    };
    if (v.min instanceof Data_Maybe.Nothing && v.max instanceof Data_Maybe.Just) {
        return function (v1) {
            return v1 <= v.max.value0;
        };
    };
    if (v.min instanceof Data_Maybe.Just && v.max instanceof Data_Maybe.Just) {
        return function (v1) {
            return v1 >= v.min.value0 && v1 <= v.max.value0;
        };
    };
    return Data_Function["const"](true);
};
var isStringFilterEnabled = function (v) {
    if (v.string instanceof Data_Maybe.Just) {
        return true;
    };
    return false;
};
var isSelectionFilterEnabled = function (v) {
    if (v.selection instanceof Data_Maybe.Just) {
        return true;
    };
    return false;
};
var isNumericFilterEnabled = function (v) {
    if (v.min instanceof Data_Maybe.Nothing && v.max instanceof Data_Maybe.Nothing) {
        return false;
    };
    return true;
};
var isDateFilterEnabled = function (v) {
    if (v.min instanceof Data_Maybe.Nothing && v.max instanceof Data_Maybe.Nothing) {
        return false;
    };
    return true;
};
var genericVisibility = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Visible.value;
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return Hidden.value;
        };
        throw new Error("Failed pattern match at FoldingTable.Filter (line 85, column 1 - line 85, column 58): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Visible) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Hidden) {
            return new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value);
        };
        throw new Error("Failed pattern match at FoldingTable.Filter (line 85, column 1 - line 85, column 58): " + [ x.constructor.name ]);
    }
};
var writeVisibility = {
    writeImpl: (function () {
        var $58 = TofuJSON.writeImpl(TofuJSON.tofuJSONVariant()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "Hidden";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "Visible";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantNil)))(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "Hidden";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "Visible";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.nilWriteForeignVariant))));
        var $59 = Kishimen.genericSumToVariant(genericVisibility)(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "Visible";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "Hidden";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "Visible";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "Hidden";
            }
        })));
        return function ($60) {
            return $58($59($60));
        };
    })(),
    readImpl: (function () {
        var $61 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(Kishimen.variantToGenericSum(genericVisibility)(Kishimen.genericSumToVariantSum(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "Visible";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))(Kishimen.genericSumToVariantConstructor({
            reflectSymbol: function () {
                return "Hidden";
            }
        })()(Kishimen.genericSumToVariantArgNoArguments))()()()()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "Visible";
            }
        }))()(Data_Variant_Internal.variantTagsCons(Data_Variant_Internal.variantTagsNil)({
            reflectSymbol: function () {
                return "Hidden";
            }
        }))));
        var $62 = TofuJSON.readImpl(TofuJSON.tofuJSONVariant()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "Hidden";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantCons({
            reflectSymbol: function () {
                return "Visible";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.readVariantNil)))(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "Hidden";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.consWriteForeignVariant({
            reflectSymbol: function () {
                return "Visible";
            }
        })(TofuJSON.readRecord()(TofuJSON.readFieldsNil)(TofuJSON.nilWriteForeignFields))()(TofuJSON.nilWriteForeignVariant))));
        return function ($63) {
            return $61($62($63));
        };
    })()
};
var fromNullable = function (defaultValue) {
    var $64 = Data_Maybe.fromMaybe(defaultValue);
    return function ($65) {
        return $64(Data_Nullable.toMaybe($65));
    };
};
var intFromNullableNumber = (function () {
    var $66 = fromNullable(0.0);
    return function ($67) {
        return Data_Int.floor($66($67));
    };
})();
var parseDate = (function () {
    var $68 = fromNullable("");
    return function ($69) {
        return Utils.lossyParseJSDate($68($69));
    };
})();
var filterProjectList = function (quickFilterString) {
    return function (projects) {
        var quickFilterPattern = Data_String_Pattern.Pattern(Data_String_Common.toLower(quickFilterString));
        var matches = function (pattern) {
            return function (value) {
                return Data_String_CodeUnits.contains(pattern)(Data_String_Common.toLower(value));
            };
        };
        var matchesPattern = function (proj) {
            return matches(quickFilterPattern)(Data_Show.show(Types_Project.showProjectCode)(proj.code)) || matches(quickFilterPattern)(proj.name);
        };
        return Data_Array.filter(matchesPattern)(projects);
    };
};
var filterInvoices = function (pattern) {
    return function (invoices) {
        var matches = function (val) {
            return Data_String_CodeUnits.contains(pattern)(Data_String_Common.toLower(Data_Maybe.fromMaybe("")(Data_Nullable.toMaybe(val))));
        };
        return Data_Array.filter(function (i) {
            return matches(Data_Nullable.toNullable(new Data_Maybe.Just(Data_Show.show(Data_Nullable.showNullable(Types_CostGroup.showCostGroupCode))(i.costGroupCode)))) || matches(i.supplier);
        })(invoices);
    };
};
var eqVisibility = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Visible && y instanceof Visible) {
                return true;
            };
            if (x instanceof Hidden && y instanceof Hidden) {
                return true;
            };
            return false;
        };
    }
};
var portfolioAreAllHidden = function (conf) {
    return Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "version";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "taxRate";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "targetIncome";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "targetDiffAndMargin";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "targetCosts";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "state";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "startDate";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "projectType";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "projectManager";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "projectGroup";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "ownProject";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "name";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "financingType";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "estimatedIncome";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "estimatedDiffAndMargin";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "estimatedCosts";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "endDate";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "contractType";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "contractPrice";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "constructionType";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "code";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "actualIncomeApproved";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "actualIncome";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "actualDiffAndMarginApproved";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "actualDiffAndMargin";
        }
    })(eqVisibility))()({
        reflectSymbol: function () {
            return "actualCosts";
        }
    })(eqVisibility)))(conf)({
        code: Hidden.value,
        name: Hidden.value,
        version: Hidden.value,
        projectManager: Hidden.value,
        targetCosts: Hidden.value,
        estimatedCosts: Hidden.value,
        actualCosts: Hidden.value,
        targetIncome: Hidden.value,
        estimatedIncome: Hidden.value,
        actualIncome: Hidden.value,
        actualIncomeApproved: Hidden.value,
        targetDiffAndMargin: Hidden.value,
        actualDiffAndMargin: Hidden.value,
        actualDiffAndMarginApproved: Hidden.value,
        estimatedDiffAndMargin: Hidden.value,
        startDate: Hidden.value,
        endDate: Hidden.value,
        contractType: Hidden.value,
        state: Hidden.value,
        projectType: Hidden.value,
        financingType: Hidden.value,
        constructionType: Hidden.value,
        contractPrice: Hidden.value,
        taxRate: Hidden.value,
        ownProject: Hidden.value,
        projectGroup: Hidden.value
    });
};
var emptyPortfolioFilterConfig = (function () {
    var emptyStringFilter = {
        string: Data_Maybe.Nothing.value
    };
    var emptySelectionFilter = {
        selection: Data_Maybe.Nothing.value
    };
    var emptyNumericFilter = {
        min: Data_Maybe.Nothing.value,
        max: Data_Maybe.Nothing.value
    };
    var emptyDateFilter = {
        min: Data_Maybe.Nothing.value,
        max: Data_Maybe.Nothing.value
    };
    return {
        code: emptyStringFilter,
        name: emptyStringFilter,
        version: emptyStringFilter,
        projectManager: emptySelectionFilter,
        targetCosts: emptyNumericFilter,
        estimatedCosts: emptyNumericFilter,
        actualCosts: emptyNumericFilter,
        targetIncome: emptyNumericFilter,
        estimatedIncome: emptyNumericFilter,
        actualIncome: emptyNumericFilter,
        actualIncomeApproved: emptyNumericFilter,
        targetDiffAndMargin: emptyNumericFilter,
        actualDiffAndMargin: emptyNumericFilter,
        actualDiffAndMarginApproved: emptyNumericFilter,
        estimatedDiffAndMargin: emptyNumericFilter,
        startDate: emptyDateFilter,
        endDate: emptyDateFilter,
        contractType: emptySelectionFilter,
        state: emptySelectionFilter,
        projectType: emptySelectionFilter,
        financingType: emptyStringFilter,
        constructionType: emptyStringFilter,
        contractPrice: emptyNumericFilter,
        taxRate: emptyNumericFilter,
        ownProject: emptySelectionFilter,
        projectGroup: emptyStringFilter
    };
})();
var dateFilterFunction = function (v) {
    if (v.min instanceof Data_Maybe.Just && v.max instanceof Data_Maybe.Nothing) {
        return function (date) {
            return Data_Ord.greaterThanOrEq(Data_JSDate.ordJSDate)(date)(v.min.value0);
        };
    };
    if (v.min instanceof Data_Maybe.Nothing && v.max instanceof Data_Maybe.Just) {
        return function (date) {
            return Data_Ord.lessThanOrEq(Data_JSDate.ordJSDate)(date)(v.max.value0);
        };
    };
    if (v.min instanceof Data_Maybe.Just && v.max instanceof Data_Maybe.Just) {
        return function (date) {
            return Data_Ord.greaterThanOrEq(Data_JSDate.ordJSDate)(date)(v.min.value0) && Data_Ord.lessThanOrEq(Data_JSDate.ordJSDate)(date)(v.max.value0);
        };
    };
    return Data_Function["const"](true);
};
var matchesFilter = function (filterConf) {
    return function (project) {
        return Data_Foldable.and(Data_Foldable.foldableArray)(Data_HeytingAlgebra.heytingAlgebraBoolean)([ stringFilterFunction(filterConf.code)(Data_Newtype.unwrap()(project.code)), stringFilterFunction(filterConf.name)(project.name), stringFilterFunction(filterConf.version)(project.version), selectionFilterFunction(filterConf.projectManager)(project.projectManager), numericFilterFunction(filterConf.targetCosts)(intFromNullableNumber(project.targetCosts)), numericFilterFunction(filterConf.estimatedCosts)(intFromNullableNumber(project.estimatedCosts)), numericFilterFunction(filterConf.actualCosts)(intFromNullableNumber(project.actualCosts)), numericFilterFunction(filterConf.targetIncome)(intFromNullableNumber(project.targetIncome)), numericFilterFunction(filterConf.estimatedIncome)(intFromNullableNumber(project.estimatedIncome)), numericFilterFunction(filterConf.actualIncome)(intFromNullableNumber(project.actualIncome)), numericFilterFunction(filterConf.actualIncomeApproved)(intFromNullableNumber(project.actualIncomeApproved)), numericFilterFunction(filterConf.targetDiffAndMargin)(intFromNullableNumber(project.targetDiff)), numericFilterFunction(filterConf.actualDiffAndMargin)(intFromNullableNumber(project.actualDiff)), numericFilterFunction(filterConf.actualDiffAndMarginApproved)(intFromNullableNumber(project.actualDiffApproved)), numericFilterFunction(filterConf.estimatedDiffAndMargin)(intFromNullableNumber(project.estimatedDiff)), dateFilterFunction(filterConf.startDate)(parseDate(project.startDate)), dateFilterFunction(filterConf.endDate)(parseDate(project.endDate)), selectionFilterFunction(filterConf.contractType)(project.contractType), selectionFilterFunction(filterConf.state)(project.state), selectionFilterFunction(filterConf.projectType)(project.projectType), stringFilterFunction(filterConf.financingType)(project.financingType), stringFilterFunction(filterConf.constructionType)(project.constructionType), numericFilterFunction(filterConf.contractPrice)(Data_Int.floor(project.contractPrice)), numericFilterFunction(filterConf.taxRate)(Data_Maybe.fromMaybe(0)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Functor.map(Data_Functor.functorFn)(Data_Int.floor)(Data_Newtype.unwrap()))(project.taxRate))), selectionFilterFunction(filterConf.ownProject)(Locale.lookup_("own_project_" + Data_Show.show(Data_Show.showBoolean)(project.ownProject))), stringFilterFunction(filterConf.projectGroup)(project.projectGroup) ]);
    };
};
var filterPortfolioProjects = function (quickFilterString) {
    return function (filterConf) {
        return function (projects) {
            var quickFilterPattern = Data_String_Pattern.Pattern(Data_String_Common.toLower(quickFilterString));
            var matches = function (pattern) {
                return function (value) {
                    return Data_String_CodeUnits.contains(pattern)(Data_String_Common.toLower(value));
                };
            };
            var matchesPattern = function (proj) {
                return matches(quickFilterPattern)(Data_Show.show(Types_Project.showProjectCode)(proj.code)) || matches(quickFilterPattern)(proj.name);
            };
            return Data_Array.filter(function (proj) {
                return matchesPattern(proj) && matchesFilter(filterConf)(proj);
            })(projects);
        };
    };
};
module.exports = {
    Visible: Visible,
    Hidden: Hidden,
    filterInvoices: filterInvoices,
    filterPortfolioProjects: filterPortfolioProjects,
    filterProjectList: filterProjectList,
    emptyPortfolioFilterConfig: emptyPortfolioFilterConfig,
    isStringFilterEnabled: isStringFilterEnabled,
    isNumericFilterEnabled: isNumericFilterEnabled,
    isDateFilterEnabled: isDateFilterEnabled,
    isSelectionFilterEnabled: isSelectionFilterEnabled,
    portfolioAreAllHidden: portfolioAreAllHidden,
    genericVisibility: genericVisibility,
    eqVisibility: eqVisibility,
    writeVisibility: writeVisibility
};
